import { FileText, Mail, FolderOpen, User, Building2, type LucideIcon } from 'lucide-react';
import type { SearchResult, SearchGroup } from '../../lib/search-types';

const GROUP_ICONS: Record<SearchGroup, LucideIcon> = {
  Saker: FolderOpen,
  Hendelser: Mail,
  Dokumenter: FileText,
  Personer: User,
  Organisasjoner: Building2,
};

interface PaletteItemProps {
  result: SearchResult;
  isActive: boolean;
  onSelect: (result: SearchResult) => void;
  onMouseEnter: () => void;
}

export function PaletteItem({ result, isActive, onSelect, onMouseEnter }: PaletteItemProps) {
  const Icon = GROUP_ICONS[result.group];

  return (
    <button
      role="option"
      aria-selected={isActive}
      className={`
        flex w-full items-center gap-3 px-4 py-2.5 text-left
        transition-colors duration-75
        ${isActive ? 'bg-accent/12 text-text-primary' : 'text-text-primary hover:bg-white/4'}
      `}
      onMouseEnter={onMouseEnter}
      onClick={() => onSelect(result)}
    >
      <Icon size={14} className={`shrink-0 ${isActive ? 'text-accent' : 'text-text-secondary'}`} />
      <span className="flex-1 truncate text-sm">{result.title}</span>
      {result.subtitle && (
        <span className="shrink-0 text-xs text-text-secondary">{result.subtitle}</span>
      )}
    </button>
  );
}
